import React from 'react';
import { ArrowRightIcon, PlaneTakeoffIcon, IdCardIcon } from 'lucide-react';
import type { PathKey } from '../types/content';
interface HeroProps {
  path: PathKey;
  onPathChange: (path: PathKey) => void;
}
const doors: Array<{
  key: PathKey;
  title: string;
  body: string;
  cta: string;
  Icon: typeof PlaneTakeoffIcon;
}> = [{
  key: 'decouverte',
  title: 'Je découvre l’ULM',
  body: 'Les six classes, le coût réel, la formation, et une base près de chez vous.',
  cta: 'Commencer la découverte',
  Icon: PlaneTakeoffIcon
}, {
  key: 'licencie',
  title: 'Je suis licencié',
  body: 'Licence et assurance, sécurité des vols, agenda fédéral et compétitions.',
  cta: 'Accéder à mon parcours',
  Icon: IdCardIcon
}];
export function Hero({
  path,
  onPathChange
}: HeroProps) {
  return <section id="top" className="relative bg-ink" data-id="element-86" data-mp="3d2ldtocrhr6i">
      <div className="relative h-[74vh] min-h-[520px] w-full overflow-hidden" data-id="element-87" data-mp="382fdzkwc8ydc">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/3b594246-67eb-4c02-95e8-ecb6b3aaadd8.jpg" alt="Vue depuis le cockpit d’un ULM en vol au-dessus de la campagne française" className="h-full w-full object-cover" data-id="element-88" data-mp="384jsewrv5frv" />
        <div className="absolute inset-0 bg-ink/60" aria-hidden="true" data-id="element-89" data-mp="399jq3lb5st9t" />
        <div className="absolute inset-y-0 left-0 hidden w-1/2 bg-ink/35 lg:block" aria-hidden="true" data-id="element-90" data-mp="3e8mud3jbevgq" />

        <div className="absolute inset-0 flex items-center" data-id="element-91" data-mp="30hrjxmt646b1">
          <div className="mx-auto w-full max-w-shell px-5 lg:px-8" data-id="element-92" data-mp="358rckfv9827q">
            <p className="ffp-display text-[13px] font-semibold uppercase tracking-[0.16em] text-white/70" data-id="element-93" data-mp="35a2gqgsm3bzd">
              Fédération Française d’ULM
            </p>
            <h1 className="ffp-display mt-4 max-w-2xl text-4xl font-extrabold leading-[1.02] text-white sm:text-5xl lg:text-6xl" data-id="element-94" data-mp="2vi56bc9fgo1p">
              L’aviation la plus légère,
              <br data-id="element-95" data-mp="2lkilya9d04ac" />
              la plus libre de France.
            </h1>
            <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-white/85" data-id="element-96" data-mp="2lmuyu909fogj">
              16 000 pilotes, 1 200 bases, six façons de voler. La Fédération forme, assure, représente
              et accompagne toute la pratique de l’ULM en France.
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto -mt-14 max-w-shell px-5 pb-16 lg:-mt-20 lg:px-8" data-id="element-97" data-mp="i9vp4yrrfqj7">
        <div className="grid gap-4 md:grid-cols-2" data-id="element-98" data-mp="deyh9v67vn7w">
          {doors.map(door => {
          const active = door.key === path;
          return <button key={door.key} type="button" onClick={() => onPathChange(door.key)} aria-pressed={active} className={`ffp-focus group relative overflow-hidden rounded-xl border p-6 text-left transition-colors duration-200 ease-soft lg:p-8 ${active ? 'border-navy bg-white shadow-xl shadow-ink/10' : 'border-white/15 bg-white/95 hover:border-navy/40'}`} data-id="element-99" data-mp="161jc55lwihg7">
                <span className={`absolute inset-y-0 left-0 w-1 ${active ? 'bg-flag' : 'bg-transparent'}`} aria-hidden="true" data-id="element-100" data-mp="1xavvwffu8055" />
                <door.Icon className="h-6 w-6 text-azure" aria-hidden="true" data-id="element-101" data-mp="2697lqf8vqtwj" />
                <h2 className="ffp-display mt-4 text-2xl font-bold text-ink lg:text-[28px]" data-id="element-102" data-mp="2b0zemwfidbpu">{door.title}</h2>
                <p className="mt-2 max-w-md text-[15px] leading-relaxed text-ink/65" data-id="element-103" data-mp="2fyr5dn4f2rsg">{door.body}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-[14px] font-semibold text-navy" data-id="element-104" data-mp="2kxublaw4v420">
                  {door.cta}
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-soft group-hover:translate-x-1" aria-hidden="true" data-id="element-105" data-mp="2p1a9eajxvaga" />
                </span>
              </button>;
        })}
        </div>
      </div>
    </section>;
}